// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ruleGroup {\n    background: rgba(94, 0, 177, 0.2) !important\n}", "",{"version":3,"sources":["webpack://./src/components/condition/condition.styles.css"],"names":[],"mappings":"AAAA;IACI;AACJ","sourcesContent":[".ruleGroup {\n    background: rgba(94, 0, 177, 0.2) !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
